// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2mKW3","productName":"Table_productName__18Ans"};